import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Index from '../views/Index.vue'
import Login from '../views/Login.vue'
import registered from '../views/registered.vue'
import website from '../views/website.vue'
import myCenter from '../views/myCenter.vue'
import provide from '../views/provide.vue'
import volunteer from '../views/volunteer.vue'
import consult from '../views/consult.vue'
import webLogin from '../views/webLogin.vue'
import organization from '../views/organization.vue'
import information from '../views/information.vue'
import consultDetail from '../views/consultDetail.vue'
import upload from '../views/upload.vue'
import list from '../views/serviceList.vue'



import store from "../store";
import axios from "../axios";

Vue.use(VueRouter)
const routes = [
    {
        // 前端首页
        path: '/',
        name: 'website',
        component: website,
    },
    {
        path: '/Home',
        name: 'Home',
        component: Home,
        children: [
            {
                path: '/Index',
                name: 'Index',
                meta: {
                    title: "首页"
                },
                component: Index
            }, {
                path: '/userCenter',
                name: 'UserCenter',
                meta: {
                    title: "个人中心"
                },
                component: () => import('@/views/UserCenter')
            }
        ]
    },

    // {
    //     path: '/login',
    //     name: 'Login',
    //     component: Login
    // },
    {
        // 前端登录
        path: '/webLogin',
        name: 'webLogin',
        component: webLogin
    },
    {
        // 前端注册
        path: '/registered',
        name: 'registered',
        component: registered
    },

    {
        // 养老机构
        path: '/organization',
        name: 'organization',
        component: organization,
    },
    {
        // 养老资讯
        path: '/provide',
        name: 'provide',
        component: provide
    },
    {
        // 资讯详情
        path: '/information',
        name: 'information',
        component: information
    },
    {
        // 志愿者
        path: '/volunteer',
        name: 'volunteer',
        component: volunteer
    },
    {
        // 技能培训列表页
        path: '/consult',
        name: 'consult',
        component: consult
    },
    {
        // 技能培训列表页
        path: '/consultDetail',
        name: 'consultDetail',
        component: consultDetail
    },
    {
        path: '/myCenter',
        name: 'myCenter',
        component: myCenter
    },
    {
        path: '/upload',
        name: 'upload',
        component: upload
    },
    {
        path: '/serviceList',
        name: 'serviceList',
        component: list
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
    routes
})

router.beforeEach((to, from, next) => {
    let hasRoute = store.state.menus.hasRoutes
    let token = localStorage.getItem("token")
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (to.path == '/') {
        next()
    } else if (!token) {
        next()
    } else if (token && !hasRoute) {
        if(userInfo.role==3){
            next()
        }else{
            axios.get("/gw/sys/menu/nav", {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            }).then(res => {
                store.commit("setMenuList", res.data.data.nav)
                store.commit("setPermList", res.data.data.authoritys)

                let newRoutes = router.options.routes
                res.data.data.nav.forEach(menu => {
                    if (menu.children) {
                        menu.children.forEach(e => {
                            let route = menuToRoute(e)
                            if (route) {
                                newRoutes[1].children.push(route)
                            }
                        })
                    }
                })
                router.addRoutes(newRoutes)
                hasRoute = true
                store.commit("changeRouteStatus", hasRoute)
            })
        }
    }
    next()
})

const menuToRoute = (menu) => {
    if (!menu.component) {
        return null
    }

    let route = {
        name: menu.name,
        path: menu.path,
        meta: {
            icon: menu.icon,
            title: menu.title
        }
    }
    route.component = () => import('@/views/' + menu.component + '.vue')

    return route
}

export default router
